import React from 'react';
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface DosenInfoModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  text: string;
}

const DosenInfoModal: React.FC<DosenInfoModalProps> = ({ open, onClose, title, text }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '450px',
          p: '30px',
          background: '#0F0F0F',
          borderRadius: '10px',
          outline: '1px solid var(--Stroke-Modal-border, #2A2A2A)',
          outlineOffset: '-1px'
        }
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <Typography
            sx={{
              flex: 1,
              color: 'var(--Text-text-primary, #FDFDFD)',
              fontSize: 24,
              fontWeight: 500,
              fontFamily: 'Inter, sans-serif'
            }}
          >
            {title}
          </Typography>
          <IconButton onClick={onClose} sx={{ p: 0.75 }}>
            <CloseIcon sx={{ fontSize: '25px', color: '#FDFDFD' }} />
          </IconButton>
        </Box>

        <Typography
          sx={{
            color: '#B6B6B6',
            fontSize: '14px',
            fontWeight: 400,
            fontFamily: 'Inter, sans-serif',
            lineHeight: '20px'
          }}
        >
          {text}
        </Typography>
      </Box>
    </Dialog>
  );
};

export default DosenInfoModal;
